
  // Showing All Available Options  
    function showAvailableOptions(selectElement, index, numbOfSelects, callerID) {
      
  
    }
//--------------- Setting accessibility focus on cart ---------------------
$(function() {
  const button = $('button.button.w-100');
  //console.log('got button', button);

  const cartDrawerCloseButton = $('.cart--drawer-close a');
 // console.log(cartDrawerCloseButton);

  let previouslyFocusedElement = null;
  //console.log(previouslyFocusedElement);

  button.click(function(event) {
    // Trigger the Cart Drawer

    const firstFocusableElement = $('.cart--drawer [tabindex="0"]');
   // console.log('first focusable element',firstFocusableElement);
    if (firstFocusableElement.length > 0) {
      previouslyFocusedElement = $(document.activeElement); // Store the previously focused element
      firstFocusableElement.focus();
    }

    const pageElements = $('body > *:not(.cart--drawer)');
   // console.log('pageElements', pageElements);
    pageElements.attr('aria-hidden', 'true');
  //  console.log('made page elements hidden');

    const nonFocusableElements = $('.cart--drawer [tabindex="-1"]');
  //  console.log('non-focusable elements');
    nonFocusableElements.attr('tabindex', '-1');
  //  console.log('made nonfocusable elements', nonFocusableElements);
  });

  cartDrawerCloseButton.click(function(event) {
  //  console.log('closing cart drawer');
    event.preventDefault();
    closeCartDrawer();
  //  console.log('closed cart drawer');
  });

  function closeCartDrawer() {
    // Check if the cart drawer is already closed
    if ($('.cart--drawer').is(':hidden')) {
      return;
    } else {
      // Remove the click event handler before triggering the click
      cartDrawerCloseButton.off('click');
  
      // Close the Cart Drawer
      cartDrawerCloseButton.trigger('click');
  
      // Restore the underlying page elements
      $('body > *:not(.cart--drawer)').removeAttr('aria-hidden');
  
      // Restore focus to the previously focused element
      if (previouslyFocusedElement) {
        previouslyFocusedElement.focus();
        previouslyFocusedElement = null; // Reset the reference
      }
    }
  }
  

  $(document).keydown(function(event) {
    if (event.key === 'Escape') {
      closeCartDrawer();
   //   console.log('Closed Cart Drawer');
    }
  });

  function keyPress(e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
    }
  }

  $(document).keydown(keyPress);
});







// -----------------------PRICE SPIDER ---------------//
$(function() {
    var metaData2;
    var decoded;
    var metaJSON;

    if ($("#metaData").length > 0){
        metaData2 = $("#metaData").data("meta");
        decoded = decodeURIComponent(metaData2);
        metaJSON = JSON.parse(JSON.parse(decoded));
      }

function showWheretoBuy () {   //toggles if we show where to buy button
    var variantKey = $("#currentVariant").val();
    var isPriceSpider = metaJSON[variantKey].pricespider; 

    if (isPriceSpider === true || isPriceSpider === "true"){
      $("#whereToBuy").show();
    } else {
      $("#whereToBuy").hide();
    }
  }


  //description open on pageload
  //  $('[id^="Details-description"] summary').click();

if (metaJSON) { //if our metaJSON data is true
    var psNum = 0; //set psNum to the length of the variants

    var parent = document.createElement("div");
      parent.style = 'display:none';

    for (var variant in metaJSON) { //checking each variant is priceSpider. and for every one that IS...
      // create html div for each variant that is pricespider 
      if (metaJSON[variant].pricespider) {
        psNum += 1
      } else {
        continue;
      }

      var pricespiderButton = document.createElement("div");
        pricespiderButton.id = "priceSpiderWidget-" + variant;
        pricespiderButton.classList += 'ps-widget';
        pricespiderButton.setAttribute("ps-sku", metaJSON[variant].sku);
        
        parent.appendChild(pricespiderButton);
    }

    if (psNum > 0) {  // if it is greater that 0, then we will do our magic.
      document.getElementById("whereToBuy").appendChild(parent);

      $("#whereToBuy").click(function () {
        var variantKey = $("#currentVariant").val();
        $("#priceSpiderWidget-" + variantKey).trigger("click"); //this will check the variant key each time the function is called
      })
    }

    showWheretoBuy();
  }

  $('#whereToBuy > a').click(function() { 
    let buyNowButton = $("#priceSpiderWidget-" + $("#currentVariant").val());
    buyNowButton.trigger("click");
  });

  var updateVariantInfo = function(variantKey, variantData) {
    

    //Updating model number on PDP (not in specs section)
    $("#model-number").text("Model #:  " + variantData.sku);

    
    var slidesToAdd = [];
    var imgSlider =  document.getElementById('swiper-media');
    imgSlider.style.width="auto";

    for (const key in variantData) {
      if (variantData[key]?.toUpperCase() !== 'NULL' && ['hero', 'close', 'lifestyle'].some(k => key.includes(k))) {
        // console.log(`variant data key: ${key}`);
        const img = new Image();
        img.src = variantData[key].replace('/jpg/', '/jpg/small/');
        img.classList.add('product-featured-media', key);
        img.width = '300px';
        img.height = '300px';
        img.loading = 'lazy';
    
        const mydiv = document.createElement('div');
        mydiv.classList.add('swiper-slide');
        mydiv.appendChild(img);
    
        slidesToAdd.push(mydiv);
      } else if (variantData[key] != null && ['hero', 'close', 'lifestyle'].some(k => key.includes(k))) {
        const index = $('.' + key).parent().index();
        window.swiperMedia.removeSlide(index);
        window.swiperMediaThumbnails.removeSlide(index);
      } else {
        const el = $('.' + key);
        if (variantData[key] != null && !variantData[key].toString().includes('[object') && !variantData[key].toString().includes('9999')) {
          el.text(variantData[key] === 'false' ? 'No' : variantData[key] === 'true' ? 'Yes' : variantData[key]);
          el.parent().show();
        } else {
          el.parent().hide();
          el.text('');
        }
      }
    }
    

    window.swiperMedia.removeAllSlides();

    window.swiperMedia.appendSlide(slidesToAdd);
    window.swiperMedia.update();
    window.swiperMedia.thumbs.update();
    window.swiperMedia.slideTo(0);

  };


  $("#currentVariant").on("change", function () {
    // console.log("variant changed")
    var variantKey = $(this).val();
    var variantData = metaJSON[variantKey];
    // updating price spider
    showWheretoBuy();
    updateVariantInfo(variantKey, variantData);
    // update sku input field.
    // run function to update compatible accessories
})
})


// JavaScript code to hide disabled variants
const variantSelects = (document.querySelector('variant-selects')) ? document.querySelector('variant-selects') : document.querySelector('variant-radios');
const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects';
const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown'));
const productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
let selectedOptions = [];
variantSelects.addEventListener('change', rebuildOptions);
this.rebuildOptions();

function validCombo(inputValue, optionLevel) {
  for(let i = 0; i < productJson.length; i++) {
    if(optionLevel == 1){
      if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) {  return true; }
    } else {
      if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) {  return true; }
    }
  }
}

function rebuildOptions() {
  selectedOptions = fieldsets.map((fieldset) => {
      return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
  });

  for(let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
      const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');

      inputs.forEach(input => {
        input.disabled = (validCombo(input.value, optionLevel)) ? false : true;
        if(pickerType == 'radios'){
            const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);

            label.style.display = (input.disabled) ? "none" : ""; //Hide the option
        } else {
            input.hidden = (validCombo(input.value, optionLevel)) ? false : true;
        }
      });
  }

  for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
    if(pickerType == 'radios'){
      if(fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
          change = (fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true);
      }
    } else {
      if(fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
          change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
      }
    }
    if(change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
